__turbopack_context__.v({
  "search_pagination_direction": "SrupOG_search_pagination_direction",
});
